import { useRef, useEffect } from 'react';

export const useSyncRef = (value) => {
  const ref = useRef(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref;
};
